export default "__VITE_ASSET__A3Md60nw__"